// extracted by mini-css-extract-plugin
export var contrastLow = "_o-1";
export var externalLink = "_o-2";
export var externalLinkIcon = "_o-3";
export var link = "_o-0";
export var linkLabel = "_o-4";